export default function form() {
  jQuery(function ($) {
    //「プライバシーポリシー」の同意のチェックあり、なしの処理
    $(function () {
      $("#privacy_checked").click(function () {
        if (this.checked) {
          $("#form_submit").prop("disabled", false);
          $("#form_submit").addClass("c-btn--allowed c-btn-arrow c-btn-arrow--right").removeClass("c-btn--not-allowed");
        } else {
          $("#form_submit").prop("disabled", true);
          $("#form_submit").addClass("c-btn--not-allowed").removeClass("c-btn--allowed c-btn-arrow c-btn-arrow--right");
        }
      });
    });

    //フォームをリセットする処理
    $(function () {
      function clearForm(form) {
        $(form).find("input, select, textarea").not(":button, :submit, :reset, :hidden").val("").prop("checked", false).prop("selected", false);
        $(form).find(":radio").filter("[data-default]").prop("checked", true);
      }
    });

    //前の画面に戻る処理 --- フォーム情報を残す
    $("#form_history_back").on("click", function () {
      history.back();
    });

    //前の画面に戻る処理 --- フォーム情報をリセットする
    $("#form_back").on("click", function () {
      location.href = "./";
    });

    //フォーム入力後、次のフォームに自動的にフォーカスを移動させる
    //$(function() {
    //$('input').on('keyup', function() {
    //var max = $(this).attr('maxlength');
    //var current = $(this).val().length;
    //if(current >= max) {
    //var nextIndex = $('input').index(this) + 1;
    //$('input')[nextIndex].focus();
    //}
    //})
    //})

    // 「送信内容のご確認」ページからブラウザバックした際は「同意するボタン」をリセットする
    $(function () {
      history.replaceState(null, document.getElementsByTagName("title")[0].innerHTML, null);
      window.addEventListener(
        "popstate",
        function () {
          $("#form_submit").prop("disabled", true);
          $("#form_submit").addClass("c-btn--not-allowed").removeClass("c-btn--allowed c-btn-arrow c-btn-arrow--right");
        },
        false
      );
    });

    //recaptcha
    //-- index.html -- strat

    //エラーを表示する関数（error クラスの p 要素を追加して表示）
    function show_error(message, this$) {
      var text = "*「" + this$.closest(".p-form__input-field").find("legend").text() + "」" + message;
      this$
        .closest(".p-form__input-field")
        .find(".p-form__input-field-title")
        .append("<p class='value-error'>" + text + "</p>");
      //this$.closest('.p-form__input-field').find('.p-form__input-field-title').after("<p class='value-error'>" + text + "</p>");
      //this$.parent().append("<p class='value-error'>" + text + "</p>");
    }

    //フォームが送信される際のイベントハンドラの設定
    $("#form_contact").submit(function () {
      //エラー表示の初期化
      $("p.value-error").remove();
      $("div").removeClass("value-error");
      $("#errorDispaly").remove();

      //メールアドレスの検証
      var email = document.querySelector("#email").value.trim();
      // var email = $.trim($("#email").val());
      if (email && !/^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/gi.test(email)) {
        $("#email").closest(".p-form__input-field").find(".p-form__input-field-title").append("<p class='value-error'>*「メールアドレス」の形式が異なります。</p>");
        //$("#email").after("<p class='value-error'>*「メールアドレス」の形式が異なります。</p>");
      }

      //確認用メールアドレスの検証
      //var email_check =  $.trim($("#email_check").val());
      //if(email_check && email_check != $.trim($("input[name="+$("#email_check").attr("name").replace(/^(.+)_check$/, "$1")+"]").val())){
      //show_error("が異なります", $("#email_check"));
      //}

      //ラジオボタンの検証
      var radio_check_count = $(":radio[name=group1]:checked").length;
      if (radio_check_count === 0) {
        $("#form_contact .p-form__input-field-group1 .p-form__input-field-title").append('<p class="value-error">*「お問い合わせ項目」を選択してください。</p>');
      }

      //セレクトメニューの検証
      $("select")
        .filter(".value-required")
        .each(function () {
          if ($(this).val() == 0) {
            show_error("を選択してください。", $(this));
          }
        });

      //1行テキスト入力フォームとテキストエリアの検証
      $(":text, textarea, #tel")
        .filter(".validate")
        .each(function () {
          //必須項目の検証
          $(this)
            .filter(".value-required")
            .each(function () {
              if ($(this).val() === "") {
                show_error(" は必須です。", $(this));
              }
            });

          //数値の検証（郵便番号）
          $(this)
            .filter(".number")
            .each(function () {
              if (isNaN($(this).val())) {
                $(this).closest(".p-form__input-field").find(".p-form__input-field-title").append("<p class='value-error'>*数値のみ入力可能です。</p>");
                // $(this).parent().prepend("<p class='value-error'>数値のみ入力可能です。</p>");
              }
            });

          //電話番号の検証
          var tel = $.trim($("#tel").val());
          if (tel && !/^\(?\d{2,5}\)?[-(\.\s]{0,2}\d{1,4}[-)\.\s]{0,2}\d{3,4}$/gi.test(tel)) {
            $("#tel").closest(".p-form__input-field").find(".p-form__input-field-title").append("<p class='value-error'>*電話番号の形式が異なります（半角英数字でご入力ください）。</p>");
            // $("#tel").after("<p class='value-error'>*電話番号の形式が異なります（半角英数字でご入力ください）。</p>");
          }

          //文字数の検証
          $(this)
            .filter(".max30")
            .each(function () {
              if ($(this).val().length > 30) {
                show_error(" は30文字以内です", $(this));
              }
            });
          $(this)
            .filter(".max50")
            .each(function () {
              if ($(this).val().length > 50) {
                show_error(" は50文字以内です", $(this));
              }
            });
          $(this)
            .filter(".max100")
            .each(function () {
              if ($(this).val().length > 100) {
                show_error(" は100文字以内です", $(this));
              }
            });
          $(this)
            .filter(".max500")
            .each(function () {
              if ($(this).val().length > 500) {
                show_error(" は500文字以内です", $(this));
              }
            });
          $(this)
            .filter(".max1000")
            .each(function () {
              if ($(this).val().length > 1000) {
                show_error(" は1000文字以内でお願いします", $(this));
              }
            });
        });

      //error クラスの追加の処理
      if ($("p.value-error").length > 0) {
        //$("p.value-error").parent().addClass("value-error");
        $("html,body").animate(
          {
            scrollTop: $("p.value-error:first").offset().top - 130,
          },
          "slow"
        );
        return false;
      }
    });

    //テキストエリアに入力された文字数を表示
    $("textarea").on("keydown keyup change", function () {
      var count = $(this).val().length;
      $("#count").text(count);
      if (count > 500) {
        $("#count").css({
          color: "#d20700",
        });
        //$("#count").css({color: '#d20700'});
      } else {
        $("#count").css({
          color: "#000",
        });
      }
    });

    //-- index.html -- end

    //recaptcha
  });

  $(function () {
    $("#complete").submit(function (event) {
      var that = $(this);
      event.preventDefault();
      var action_name = "contact"; //アクション名
      grecaptcha.ready(function () {
        grecaptcha
          .execute("<?php echo $siteKey; ?>", {
            action: action_name,
          })
          .then(function (token) {
            //input 要素を生成して値にトークンを設定
            that.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            //input 要素を生成して値にアクション名を設定
            that.prepend('<input type="hidden" name="action" value="' + action_name + '">');
            //unbind で一度 submit のイベントハンドラを削除してから submit() を実行
            that.unbind("submit").submit();
          });
      });
    });
  });
}
